import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortalComponent } from './portal/portal.component';
import { AuthGuard } from './guards/auth.guard';
import { VisaoCedenteSacadoComponent } from './components/visao-cedente-sacado/visao-cedente-sacado.component';
import { CedenteGuard } from './guards/cedente.guard';
import { SacadoGuard } from './guards/sacado.guard';
import { InvestidorGuard } from './guards/investidor.guard';

const routes: Routes = [
  {
    path: 'cedente',
    component: PortalComponent,
    canActivate: [AuthGuard, CedenteGuard],
    children: [
      {
        path: 'recebiveis',
        loadChildren: () =>
          import('src/app/modules/recebiveis/recebiveis.module').then(
            (m) => m.RecebiveisModule
          ),
      },
      { path: '**', redirectTo: 'recebiveis' },
    ],
  },
  {
    path: 'sacado',
    component: PortalComponent,
    canActivate: [AuthGuard, SacadoGuard],
    children: [
      {
        path: 'recebiveis',
        loadChildren: () =>
          import('src/app/modules/recebiveis/recebiveis.module').then(
            (m) => m.RecebiveisModule
          ),
      },
      { path: '**', redirectTo: 'recebiveis' },
    ],
  },
  {
    path: 'investimento',
    component: PortalComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/investimento/investimento.module').then(
        (m) => m.InvestimentoModule
      ),
  },
  {
    path: 'recebiveis',
    component: PortalComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/recebiveis/recebiveis.module').then(
        (m) => m.RecebiveisModule
      ),
  },
  {
    path: 'operacional',
    component: PortalComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('src/app/modules/operacional/operacional.module').then(
        (m) => m.OperacionalModule
      ),
  },
  {
    path: 'visao',
    canActivate: [AuthGuard],
    component: VisaoCedenteSacadoComponent,
  },
  { path: '**', redirectTo: 'visao' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
